import React from "react";

import Box from "../Box";

const Two = props => {
  return (
    <section className="hp__block hp__block hp__block--two container">
      <div className="row hp__block__row hp__block__row--first">
        <Box
          {...props}
          id="b1"
          type="news"
          settings={props.settings.b1}
          classes="col-xs-6 col-md-6"
        />
        <Box
          {...props}
          id="b2"
          type="news"
          settings={props.settings.b2}
          classes="col-xs-6 col-md-6"
        />
      </div>
    </section>
  );
};

export default Two;
